/* eslint-disable react/jsx-props-no-spreading */

import React from 'react'
import { connect } from 'react-redux'
// Local
import { RootState } from '../../../store'

const black = '#000000'

const mapStateToProps = (state: RootState) => ({
  currentUser: state.user
})

type ReduxStateProps = ReturnType<typeof mapStateToProps>

type Props = ReduxStateProps

function ListIcon(
  props: Props
): JSX.Element {
  const {
    ...rest
  } = props
  return (
    <svg
      /**
         * Have to prop spread because popover wraps this in many
         * cases and the tooltip / popover will not work without this (prop forwarding).
        */
      { ...rest }
      className="icon reveleer-list"
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line max-len
        d="M0 4.28572H4.70591V0H0V4.28572ZM4.70591 9.64288H0V5.35716H4.70591V9.64288ZM4.70591 15.0002H0V10.7144H4.70591V15.0002ZM19.9999 9.64288H5.88218V5.35716H19.9999V9.64288ZM5.88218 15.0002H19.9999V10.7144H5.88218V15.0002ZM5.88218 4.28572V0H19.9999V4.28572H5.88218Z"
        fill={ black }
      />
    </svg>
  )
}


export default connect(mapStateToProps)(ListIcon)



